<template>
    <div>
        <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">
            <div :class="BlockProps.Shadow? 'shadow-sm mb-3' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
                <div class="container" v-bind:style="ContainerPadding">
                    <div class="row align-items-lg-center">
                        <div class="col-lg-5 mb-5 mb-lg-0 mb-10">
                            <div class="mb-5">
                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" class="display-4 text-dark mb-5" :init="EditorConfig" keyDown v-model="BlockProps.Header" tag-name="h1">
                                </omnieditor>

                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" class="fs-3" tag-name="p" :init="EditorConfig" keyDown v-model="BlockProps.Leadin">
                                </omnieditor>

                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" class="small" :init="EditorConfig" keyDown v-model="BlockProps.Content">
                                </omnieditor>

                            </div>


                            <div class="position-relative" style="top:20px;">
                                <!-- Input Card -->
                                <label class="fw-bold p-1">Service Area Confirmation</label>
                                <div class="input-card input-card-sm">

                                    <div class="input-card-form">
                                        <label for="searchForm" class="form-label visually-hidden">enter address to check</label>
                                        <input v-model="StartAddress" type="text" class="form-control form-control-lg" id="searchForm" placeholder="enter zip code to check" aria-label="enter zip code to check">
                                    </div>
                                    <button v-on:click="CheckServiceArea" type="button" class="btn btn-primary btn-lg btn-pointer">Check</button>
                                </div>
                                <div class="blink text-red fw-bold text-center mt-2" v-if="StartError">{{StartError}}</div>
                                <!-- End Input Card -->
                                <!-- SVG Shape -->
                                <figure class="position-absolute top-0 end-0 d-none d-sm-block zi-n1 mt-n7 me-n10" style="width: 4rem;">
                                    <img class="img-fluid" src="/unify/assets/svg/components/pointer-up.svg" alt="Pointer Up">
                                </figure>
                                <!-- End SVG Shape -->
                                <!-- SVG Shape -->
                                <figure class="position-absolute bottom-0 start-0 zi-n1 mb-n7" style="width: 12rem; margin-left: -10rem;">
                                    <img class="img-fluid" src="/unify/assets/svg/components/curved-shape.svg" alt="Curved Shape">
                                </figure>
                                <!-- End SVG Shape -->
                            </div>

                        </div>
                        <!-- End Col -->

                        <div class="col-lg-6">
                            <div class="position-relative">
                                <div class="position-relative">
                                    <img class="img-fluid rounded-4 shadow-lg" :src="BlockProps.Img1" alt="Field Inspection">
                                </div>

                                <!-- Media -->
                                <div v-if="BlockProps.ShowServiceTicks" class="border-1 bg-soft-success d-inline-block position-absolute top-0 start-0 bg-white w-100 rounded-pill shadow-sm p-2 mt-5 ml-0 ms-md-n10" style="max-width: 12rem;">
                                    <div class="d-flex align-items-center">

                                        <div class="flex-shrink-0">
                                            <span class="avatar avatar-sm avatar-circle">
                                                <i v-if="FieldInspectionConfig.offerResidentialUnoccupied || FieldInspectionConfig.offerResidentialOccupied" class="bi-check-circle text-primary" style="font-size:36px;"></i>
                                                <i v-else class="bi-x-circle text-red" style="font-size:36px;"></i>
                                            </span>
                                        </div>

                                        <div class="flex-grow-1 ms-2">
                                            <div class="fs-5 fw-bold mb-0 text-dark">Residential</div>

                                        </div>

                                    </div>
                                </div>
                                <!-- End Media -->
                                <!-- Media -->
                                <div v-if="BlockProps.ShowServiceTicks" class="border-1 bg-soft-success d-inline-block position-absolute top-0 bg-white w-100 rounded-pill shadow-sm p-2 ml-0 ms-md-n10" style="max-width: 12rem;margin-top:140px;">
                                    <div class="d-flex align-items-center">
                                        <div class="flex-shrink-0">
                                            <span class="avatar avatar-sm avatar-circle">
                                                <i v-if="FieldInspectionConfig.offerCommercial" class="bi-check-circle text-primary" style="font-size:36px;"></i>
                                                <i v-else class="bi-x-circle text-red" style="font-size:36px;"></i>
                                            </span>
                                        </div>
                                        <div class="flex-grow-1 ms-2">
                                            <div class="fs-5 fw-bold mb-0">Commercial</div>

                                        </div>
                                    </div>
                                </div>
                                <!-- End Media -->
                                <!-- Media -->
                                <div v-if="BlockProps.ShowServiceTicks" class="border-1 bg-soft-dark d-inline-block position-absolute top-0 bg-white w-100 rounded-pill shadow-sm p-2 ml-0 ms-md-n10" style="max-width: 12rem;margin-top:245px;">
                                    <div class="d-flex align-items-center">
                                        <div class="flex-shrink-0">
                                            <span class="avatar avatar-sm avatar-circle">
                                                <i v-if="FieldInspectionConfig.offerIndustrial" class="bi-check-circle text-primary" style="font-size:36px;"></i>
                                                <i v-else class="bi-x-circle text-red" style="font-size:36px;"></i>
                                            </span>
                                        </div>
                                        <div class="flex-grow-1 ms-2">
                                            <div class="fs-5 fw-bold mb-0">Industrial</div>

                                        </div>
                                    </div>
                                </div>
                                <!-- End Media -->

                            </div>
                        </div>
                        <!-- End Col -->
                    </div>
                    <!-- End Row -->
                </div>
            </div>
        </div>

        <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Options</h5>
                    </div>
                    <div class="modal-body">
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <propertybaseeditors :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>
                        <small style="font-size:12px;"><i class="bi bi-info-circle"></i>  Highlight Image (75kb max)</small>
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <div class="row">
                            <div class="col col-12 text">
                                <div style="display:inline-block; width: 100px !important;height: 75px !important;">
                                    <img style="object-fit:cover; width:100% !important; height:100% !important;object-position:center  !important;box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; border: 1px solid black" :src="BlockProps.Img1" alt="Image1" />
                                </div>
                                <i class="bi bi-chevron-double-right"></i>
                                <button @click="UploadNewSlideBackground(1)" type="button" style="margin-left:5px;" class="btn btn-sm btn-primary"><i class="bi bi-image"></i> Change Image</button>
                            </div>
                            <hr style="margin-top: 5px; margin-bottom:5px;" />
                        </div>

                        <propertytogglededitor propertyname="ShowServiceTicks" :blockprops="BlockProps" prompt="Show Service Ticks"></propertytogglededitor>


                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                        <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                    </div>
                </div>
            </div>
        </div>

        <div style="z-index:300" id="MessageModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="Modal Message" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title h4" id="mySmallModalLabel" v-html="ModalTitle"></h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-center">
                        <p class="fs-5 mb-4">Your address is within our service area.</p>
                        <div class="d-grid gap-2 col-md-6 mx-auto">
                            <a class="btn btn-primary shadow btn-block btn-pointer" href="/content/checkout?service=FieldInspection">Request Inspection</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'
    import { toast } from 'vue3-toastify';


    export default {
        inheritAttrs: false,
        name: 'FieldInspectionEstimate',
        mixins: [ContentBlockBase],
        props: ['fieldinspectionconfig'],
        components: {
        },
        computed:
        {
           FieldInspectionConfig: function () {
                var x = this.Store.TenantConfig;
                if (this.fieldinspectionconfig) {
                    return this.fieldinspectionconfig
                }

                if (this.Store && this.Store.TenantConfig && this.Store.TenantConfig.serviceConfigFieldInspection) {
                    return this.Store.TenantConfig.serviceConfigFieldInspection;
                }               
            }
        },
        data() {
            return {  
                AdditionalCfg: 'https://admin.notarylaunchpad.com/home/sitesettings#FieldInspectionSettings',
                StartError: '',
                ModalObj: null,
                ModalTitle: '',
                StartAddress: '',
            };
        },
        methods:
        {
            OnSlideImageUploaded: function (args) {
                if (args.success)
                {
                    if (this.BlockProps[args.idx] && args.url){
                        this.BlockProps[args.idx] = args.url;                    
                    }
                }
                
                this.EditProperties();
            },
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },
            UploadNewSlideBackground: function(idx){
                this.HideEditProperties();
                var args = {};  

                var imgProp = 'Img' + idx;
                args.ExistingFileURL = this.BlockProps[imgProp];
                args.CompleteCallback = "OnSlideImageUploaded-" + this.BlockProps.UId;
                args.CompleteCallbackData = { MaxSize: 1024 * 75, idx: imgProp, url: ''}; // this will be sent back in the callback
                args.Prompt = `Image`;
                EventHub.$emit('UploadNewAssetBlockConfig', args);
            },
            ShowModal: function (title) {
                 this.ModalTitle = title;
                 this.ModalObj.show();
             },
             CheckServiceArea: async function () {
                 this.StartError = "";
                 if (!this.StartAddress) {
                     await nextTick();
                     this.StartError = "Address can't be blank.";
                     return;
                 }

                 var input = this.StartAddress.trim();
                 // Extract zip code: support 5-digit zip at end of address, or standalone
                 var match = input.match(/\b(\d{5})\b/);
                 if (!match) {
                     this.StartError = "Please enter a valid 5-digit zip code.";
                     return;
                 }

                 var zip = parseInt(match[1], 10);
                 var config = this.FieldInspectionConfig;
                 if (!config || !config.serviceAreaZipCodes || config.serviceAreaZipCodes.length === 0) {
                     this.StartError = "Service area information is not available. Please contact support.";
                     return;
                 }

                 if (config.serviceAreaZipCodes.indexOf(zip) === -1) {
                     this.StartError = "That zip code is not in our service area. We apologize for the inconvenience.";
                     return;
                 }

                 this.ShowModal("<span style='color:green'><i class='bi-check-circle'></i> Service Area Confirmation Successful</span>");
             },
           
        },

        setup(props, context)
        {             
            return {} // anything returned here will be available for the rest of the component
        },
        created()
        {           
            EventHub.$on('OnSlideImageUploaded-' + this.BlockProps.UId, this.OnSlideImageUploaded);      
        },
        beforeUnmount()
        {
            EventHub.$off('OnSlideImageUploaded-' + this.BlockProps.UId, this.OnSlideImageUploaded);      
        },
        mounted() {
            this.ModalObj = new bootstrap.Modal(document.getElementById('MessageModal'));
            nextTick().then(() => {
      
            });
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
</style>

